import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  IconButton,
} from "@material-ui/core"
import { Delete, Add } from "@material-ui/icons"
import Select from "react-select"
import { mergeSelectedRoles } from "../../actions/roles"
import { useDispatch } from "react-redux"
import { openSnackBar } from "../../actions/snack-bar"
import { isEmpty, head } from "lodash"
import LoadingButton from "../../components/LoadingButton"

const MergeRoleDialog = ({
  mergeSelection,
  onSave,
  onClose,
  open,
  working,
  setWorking,
}) => {
  const [selectedRole, setSelectedRole] = useState({})
  const dispatch = useDispatch()

  const handleSave = () => {
    setWorking(true)
    let mainRole = !isEmpty(selectedRole) ? selectedRole : head(mergeSelection)
    let otherRoles =
      mergeSelection &&
      mergeSelection
        .map(role => (role.id !== mainRole.id ? role : null))
        .filter(el => el != null)

    let newRoleData = {
      mainRole: mainRole,
      otherRoles: otherRoles,
    }
    dispatch(mergeSelectedRoles(newRoleData))
      .then(res => {
        dispatch(onSave).then(() => {
          dispatch(openSnackBar({ message: res.message }))
        })
      })
      .catch(err => {
        onClose()
        setWorking(false)
        dispatch(openSnackBar({ message: "Error merging the roles" }))
      })
  }
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogContent
        style={{
          padding: "20px",
        }}
      >
        <Typography variant="h5">Child Merge</Typography>
      </DialogContent>
      <DialogContent style={{ minWidth: "400px" }}>
        {open &&
          !isEmpty(mergeSelection) && (
            <Box>
              <Typography component="p" style={{ fontSize: "0.9em" }}>
                Select The Title You Would like To Keep:
              </Typography>
              {mergeSelection.map((role, index) => (
                <Paper
                  elevation={3}
                  onClick={() => setSelectedRole(role)}
                  style={{
                    border: !isEmpty(selectedRole)
                      ? selectedRole.id === role.id
                        ? "2px solid #0CADFF"
                        : null
                      : head(mergeSelection).id === role.id
                        ? "2px solid #0CADFF"
                        : null,
                    margin: "10px",
                    padding: "10px",
                    cursor: "pointer",
                  }}
                  Key={`merge-role-${index + 1}`}
                >
                  <Typography component="p" style={{ fontSize: "0.9em" }}>
                    {role.name}
                  </Typography>
                </Paper>
              ))}
            </Box>
          )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          disabled={working}
          onClick={() => onClose()}
          color="secondary"
        >
          Close
        </Button>
        <Box />
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={working}
          working={working}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default MergeRoleDialog
